export default [
  { name: 'What is Bookchat?', scrollY: 0 },
  { name: 'Our Library', scrollY: 1350 },
  { name: 'Readeo App', scrollY: 1900 },
  { name: 'Reviews', scrollY: 2500 },
  { name: 'Pricing', scrollY: 3300 },
];
